import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AwaitingApprovalPage = ({ rejected = false }) => {
  const { user, logout } = useAuth();
  const email = user?.email || '';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-6 w-14 h-14 rounded-full bg-brand-50 flex items-center justify-center">
          <svg className="w-7 h-7 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {rejected ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            )}
          </svg>
        </div>

        {rejected ? (
          <>
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              Update on your DanceHall Studios signup
            </h1>
            <p className="text-gray-600 mb-2 text-sm leading-relaxed">
              We're not able to onboard your studio at this time.
            </p>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed">
              If you think this is a mistake, email{' '}
              <a href="mailto:support@mydancehall.com" className="text-brand-500 font-medium hover:text-brand-600">
                support@mydancehall.com
              </a>{' '}
              and we'll take another look.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-gray-900 mb-3">
              Your account is under review
            </h1>
            <p className="text-gray-600 mb-2 text-sm leading-relaxed">
              Thanks for signing up &mdash; we review every new teacher account personally to keep the platform safe for students.
            </p>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed">
              We'll email <span className="font-medium text-gray-900">{email}</span> as soon as you're approved (usually within 24 hours).
            </p>
          </>
        )}

        <button
          onClick={logout}
          className="text-sm text-gray-500 hover:text-gray-700 font-medium transition-colors"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default AwaitingApprovalPage;
